import * as XLSX from "xlsx";

export default (data, fileName = "exported_data.xlsx") => {
  // 1. Create a worksheet from your data
  const worksheet = XLSX.utils.json_to_sheet(data);

  // 2. Create a workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // 3. Generate a binary string representation of the workbook
  const workbookBinary = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // 4. Create a Blob from the binary string
  const blob = new Blob([workbookBinary], { type: "application/octet-stream" });

  // 5. Create a download link
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);

  // 6. Trigger download and remove the link element
  link.click();
  document.body.removeChild(link);
};
